import { Appointment } from "@elixir/types";
import { updateAssement } from "../../utils/bridges/methods";
import { logAndGetErrorResponse } from "../error";
import { ControllerReturnType } from "../types";
import {
  trackAppointmentActivity,
  AptActivityType,
} from "./appointment-activity";

export default async function submitSa({
  appointment,
  workflowId,
  assessmentId,
}: {
  appointment: Pick<Appointment, "aid" | "assessments" | "sa_cmpl">;
  workflowId: string;
  assessmentId: string;
}): Promise<ControllerReturnType<Pick<Appointment, "assessments">>> {
  try {
    const { aid } = appointment;

    await updateAssement({
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      workflowId,
      data: {
        sa_id: assessmentId,
        status: "CM"
      },
      aid
    });

    //TODO - Add activity update
    trackAppointmentActivity({
      aid,
      activity: AptActivityType.SA_UPDATED,
    });
    return { success: true };
  } catch (e) {
    return logAndGetErrorResponse(e);
  }
}
